const GSI_SCRIPT_URL = "https://accounts.google.com/gsi/client";

let gsiLoadPromise = null;
let gsiInicializado = false;

function getGoogleClientId() {
  return (process.env.VUE_APP_GOOGLE_CLIENT_ID || "").trim();
}

function loadGsiScript() {
  if (window.google?.accounts?.id) {
    return Promise.resolve();
  }

  if (gsiLoadPromise) {
    return gsiLoadPromise;
  }

  gsiLoadPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${GSI_SCRIPT_URL}"]`);
    if (existing) {
      if (window.google?.accounts?.id) {
        resolve();
        return;
      }
      existing.addEventListener("load", () => resolve());
      existing.addEventListener("error", () => reject(new Error("gsi_load_failed")));
      return;
    }

    const script = document.createElement("script");
    script.src = GSI_SCRIPT_URL;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("gsi_load_failed"));
    document.head.appendChild(script);
  });

  return gsiLoadPromise;
}

function configurarGsi(clientId, onCredential) {
  if (!gsiInicializado) {
    window.google.accounts.id.initialize({
      client_id: clientId,
      callback: (response) => {
        if (response?.credential) {
          onCredential(response.credential);
        }
      },
      // false: evita auto-login agressivo que aumenta supressão após erro.
      auto_select: false,
      cancel_on_tap_outside: true,
      context: "signin",
      itp_support: true,
    });
    gsiInicializado = true;
  }
}

function exibirPrompt() {
  return new Promise((resolve) => {
    window.google.accounts.id.prompt((notification) => {
      if (notification.isNotDisplayed()) {
        resolve({
          exibido: false,
          motivo: notification.getNotDisplayedReason?.() || "unknown",
        });
        return;
      }
      if (notification.isSkippedMoment()) {
        resolve({
          exibido: false,
          motivo: notification.getSkippedReason?.() || "skipped",
        });
        return;
      }
      if (notification.isDismissedMoment()) {
        resolve({
          exibido: false,
          motivo: notification.getDismissedReason?.() || "dismissed",
        });
        return;
      }
      resolve({ exibido: true });
    });
  });
}

/**
 * Exibe o prompt Google One Tap na tela de login.
 * O Google pode suprimir o prompt após erro, fechar (X) ou uso do botão OAuth
 * (cooldown de horas — comportamento do Google, não do app).
 */
async function iniciarOneTap({ onCredential }) {
  const clientId = getGoogleClientId();
  if (!clientId || typeof onCredential !== "function") {
    return { exibido: false, motivo: "missing_client_id" };
  }

  await loadGsiScript();

  if (!window.google?.accounts?.id) {
    return { exibido: false, motivo: "gsi_unavailable" };
  }

  configurarGsi(clientId, onCredential);

  return exibirPrompt();
}

function cancelarOneTap() {
  if (window.google?.accounts?.id?.cancel) {
    window.google.accounts.id.cancel();
  }
}

export default {
  getGoogleClientId,
  iniciarOneTap,
  cancelarOneTap,
};
